import { title } from '../../../material-kit-react';

const aboutStyle = {
  section: {
    padding: '70px 0',
    textAlign: 'center'
  },
  p: {
    color: '#555555',
    marginLeft: '-40px',
    marginRight: '-40px',
    textAlign: 'justify'
  },
  paper: {
    fontSize: '16px',
    textAlign: 'left'
  },
  title: {
    ...title,
    marginBottom: '1rem',
    marginTop: '30px',
    minHeight: '32px',
    textDecoration: 'none'
  },
  description: {
    color: '#999'
  }
};

export default aboutStyle;
